define('services/myservices/game.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('gameService', ['$q','$filter', 'ngDialog', 'OpenApp', 'auiDialog','HuaweiTrade','$state','opearteShaService','UserInfo','myServicesAddSer',
        function ($q,$filter, ngDialog, OpenApp, auiDialog,HuaweiTrade,$state,opearteShaService,UserInfo,myServicesAddSer) {

        var regexp = mainCons.servicesConstant.regexp;

        function submit(Model){
            var defer = $q.defer();
            myServicesAddSer.updatePackageNameOrWebUrl(Model).then(function(){// 修改包名
                updateAppAttrs(Model).then(function(){
                    addGameService(Model).then(function(){// 添加服务
                        $state.go('rollout.submitSuccess', {serviceItem: Model.serviceItem, product:Model.product},{reload: true});
                    }).catch(function(){
                        defer.reject();
                    });
                }).catch(function(){
                    defer.reject();
                });
            }).catch(function(){
                defer.reject();
            });
            return defer.promise;
        }

        function addGameService(Model){
            var defer = $q.defer();
            var appInfo = Model.product.appInfo;
            if (Model.product.serviceSingle && Model.product.serviceSingle.srvSerialNo){
                OpenApp.updateService({ request: {
                    prodID: Model.product.prodID,
                    serviceItem: '52',
                    prodType: Model.product.appInfo.prodType
                }});
                defer.resolve();
            }else {
                var addServiceParams = {
                    request: {
                        prodID: appInfo.appID,
                        prodType: appInfo.prodType,
                        serviceItem: 52
                    }
                };
                var serviceAttrs = {};
                serviceAttrs.callbackUrl = Model.selected.callbackUrl || "";
                addServiceParams.request.serviceAttrs = JSON.stringify(serviceAttrs);

                OpenApp.addService(addServiceParams).then(function (addData) {
                    if (addData && addData.srvSerialNo) {
                        defer.resolve();
                    }else{
                        defer.reject();
                    }
                }).catch(function (data) {
                    defer.reject();
                });
            }
            return defer.promise;
        }

        function updateAppAttrs(Model){
            var defer = $q.defer();
            var getAtrrs = {
                request: {
                    appID: Model.product.prodID,
                    serviceItem: 52
                }
            };
            var appInfo = Model.product.appInfo;
            // 1.更新指纹、回调地址
            var appAttrs = {};
            if (appInfo && appInfo.appAttrs) {
                appAttrs = angular.fromJson(appInfo.appAttrs);
            }
            if(Model.selected.webAppUrl){
                appAttrs.webAppUrl =Model.selected.webAppUrl;
            }
            // webapp、免安装的h5没有指纹
            opearteShaService.opearteShaService(appAttrs,Model.selected);

            getAtrrs.request.appAttrs = JSON.stringify(appAttrs);
            OpenApp.updateAppAttrs(getAtrrs).then(function (getAtrrsData) {
                if (getAtrrsData && getAtrrsData.prodSerialNo) {
                    // 发送消息给网关，异步处理。
                    opearteShaService.sendMsgToOpenGWapi(Model.product.prodID);
                    defer.resolve();
                }else{
                    defer.reject();
                }
            }).catch(function (data) {
                defer.reject();
            });
            return defer.promise;
        }

        return {
            submit: submit
        }

    }]);
});


